import {
  CalendarIcon,
  DocumentArrowUpIcon,
  PencilIcon,
  UsersIcon,
  WrenchIcon,
  EyeIcon,
  EyeSlashIcon,
} from "@heroicons/react/24/outline";
import { PMPagination } from "../../utils/PMPagination";
import { TWclassNames } from "../../utils/Div";
import { dateToString, StringLimit } from "../../Utils";
import { Link } from "react-router-dom";
import { ResourceEmpty } from "../../utils/ResourceEmpty";
import { updateWebPage } from "../../../api/webpage/pages";
import toast from "react-hot-toast";
import { useState } from "react";

export const PagesTable = (props) => {
  const {
    itemState,
    onPageChange,
    itemsCount,
    currentCount,
    page,
    perPage,
    onItemsSelect,
  } = props;
  const { data, isLoading, errors } = itemState;
  const [publishing, setPublishing] = useState({});

  const handleTogglePublish = async (item, e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const newPublishedStatus = !item.published;
    setPublishing({ ...publishing, [item.id]: true });
    
    try {
      await updateWebPage({
        id: item.id,
        published: newPublishedStatus,
      });
      toast.success(newPublishedStatus ? "Side publisert" : "Side avpublisert");
      // Refresh the page list by triggering a reload
      window.location.reload();
    } catch (error) {
      console.error("Error updating page:", error);
      toast.error("Kunne ikke oppdatere publiseringsstatus");
      setPublishing({ ...publishing, [item.id]: false });
    }
  };

  return (
    <div>
      {data.length > 0 && (
        <PMPagination
          disabled={isLoading}
          onPageChange={onPageChange}
          page={page}
          perPage={perPage}
          rowsCount={itemsCount}
          totalCount={itemsCount}
          currentCount={currentCount}
          showCount={false}
          showPages={false}
        />
      )}
      <div className="flex flex-col">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div className="relative overflow-hidden  md:rounded-lg">
              {data && data.length > 0 ? (
                <div className="overflow-hidden bg-white shadow sm:rounded-lg">
                  <ul role="list" className="divide-y divide-gray-200">
                    {data?.map((item) => (
                      <li
                        key={item?.id}
                        className="flex justify-between items-center"
                      >
                        <Link
                          className="px-6 py-6 sm:px-8 flex-grow hover:bg-gray-50"
                          to={`/dashboard/webpage/pages/${item?.slug}`}
                        >
                          <div className="flex justify-between">
                            <div className="flex flex-col justify-between">
                              <div className="flex items-center gap-2">
                                <div className="grid">
                                  <div className="mb-2"></div>
                                  <p className="truncate text-xl font-medium text-blue-600">
                                    {item?.title}
                                  </p>
                                </div>
                                {item?.published ? (
                                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                    Publisert
                                  </span>
                                ) : (
                                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                                    Ikke publisert
                                  </span>
                                )}
                              </div>
                              <div className="mt-2 sm:flex sm:justify-between">
                                <div className="sm:flex">
                                  <p className="flex items-center text-sm text-gray-600">
                                    <UsersIcon
                                      className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-500"
                                      aria-hidden="true"
                                    />
                                    <span className="font-bold mr-1">
                                      Oppdatert av:{" "}
                                    </span>
                                    {item?.created_by?.name
                                      ? StringLimit(item?.created_by?.name, 20)
                                      : "Mangler info"}
                                  </p>

                                  {item?.executing_employee?.id && (
                                    <p className="sm:ml-2 flex items-center text-sm text-gray-600">
                                      <WrenchIcon
                                        className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-500"
                                        aria-hidden="true"
                                      />
                                      {item?.executing_employee?.name}
                                    </p>
                                  )}
                                </div>
                                <div className="sm:ml-2 flex items-center text-sm text-gray-600">
                                  <CalendarIcon
                                    className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-500"
                                    aria-hidden="true"
                                  />
                                  <p>
                                    Sist oppdatert:{" "}
                                    <time dateTime={item?.updated_at}>
                                      {/* {item?.appointment?.date || "Ikke avtalt"} */}
                                      {dateToString(item?.updated_at)}
                                    </time>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>
                        <div className="px-6 py-6 flex items-center gap-2">
                          <button
                            onClick={(e) => handleTogglePublish(item, e)}
                            disabled={publishing[item.id]}
                            className={`p-2 rounded ${
                              item?.published
                                ? "bg-yellow-100 text-yellow-800 hover:bg-yellow-200"
                                : "bg-green-100 text-green-800 hover:bg-green-200"
                            } disabled:opacity-50 disabled:cursor-not-allowed`}
                            title={item?.published ? "Avpubliser side" : "Publiser side"}
                          >
                            {publishing[item.id] ? (
                              <div className="w-5 h-5 border-2 border-current border-t-transparent rounded-full animate-spin" />
                            ) : item?.published ? (
                              <EyeSlashIcon className="w-5 h-5" />
                            ) : (
                              <EyeIcon className="w-5 h-5" />
                            )}
                          </button>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <ResourceEmpty text="Ingen sider funnet! " />
              )}
            </div>
          </div>
        </div>
      </div>
      {data.length > 0 && (
        <PMPagination
          disabled={isLoading}
          onPageChange={onPageChange}
          page={page}
          perPage={perPage}
          rowsCount={itemsCount}
          totalCount={itemsCount}
          currentCount={currentCount}
          showCount={true}
        />
      )}
    </div>
  );
};

PagesTable.defaultProps = {
  page: 1,
  itemState: [],
  itemsCount: 0,
  selectedItems: [],
  sort: "desc",
  sortBy: "createdAt",
};
